import { Link } from "office-ui-fabric-react";

const TimesheetApprovalsTooltip = () => {
    return (
        <span>
            Define whether timesheet approvals should be enabled in your PPM Express tenant. Please refer to the{" "}
            <Link href="https://help.ppm.express/time-tracking/timesheet-approvals" target="_blank">
                article
            </Link>{" "}
            for more details.
        </span>
    );
};

export default TimesheetApprovalsTooltip;
